function roundUpFilter() {
    'ngInject';

    return function (number, interval) {
        let result = number / interval;
        result = parseInt(result);
        result = result * interval;
        if ((number % interval) > 0) {
            result = result + interval;
        }
        return result;
    };
}

angular
    .module('BB')
    .filter('round_up', roundUpFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/round_up.filter.js